import { Fragment, useState } from 'react';
import { useForm } from 'react-hook-form';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../security/hooks/axiosProvider';
import styles from '../../../styles/style-setting.module.scss';

const CreateUnit = (props) => {
  const {
    register,
    handleSubmit,
    resetField,
    formState: { errors },
  } = useForm();
  const [CreateUnitModal, setCreateUnitModal] = useState(false);
  const [Open, setOpen] = useState(false);
  const httpClient = useHttpClient(true);
  const CreateModalToggle = () => resetForm();
  const Toggle = () => setOpen(!Open);
  const [spinner, setSpinner] = useState(false);

  const onSubmit = async (data) => {
    const unitData = { name: data['unit_name'], description: data['unit_description'], value: data['unit_value'] };
    try {
      setSpinner(true);
      const response = httpClient.current?.post(`/api/unit`, unitData);
      if ((await response).status === 200) {
        setSpinner(false);
        props.units();
        resetForm();
      }
    } catch (error) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const handleCancel = () => {
    resetForm();
  };

  const resetForm = () => {
    resetField('unit_name');
    resetField('unit_value');
    resetField('unit_description');
    setCreateUnitModal(!CreateUnitModal);
  };

  return (
    <>
      <Button outline color="success" onClick={CreateModalToggle}>
        {' '}
        {props.t('create_unit')}
      </Button>
      <Modal isOpen={CreateUnitModal} toggle={CreateModalToggle} centered>
        <ModalHeader toggle={CreateModalToggle}>{props.t('create_unit')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={Open} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            {spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                <FormGroup className="form-row">
                  <label htmlFor={'unit_name'}>{props.t('unit_name')}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="unit_name"
                    id="unit_name"
                    aria-invalid={errors.unit_name ? 'true' : 'false'}
                    placeholder={props.t('enter_unit_name')}
                    {...register('unit_name', { required: true })}
                  />
                  <span>{errors.unit_name && <p>{props.t('errors_champ')}</p>}</span>
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor="unit_description">{props.t('Description')}</label>
                  <textarea
                    className="form-control"
                    name="unit_description"
                    {...register('unit_description')}
                    id="unit_description"
                    rows={3}
                    placeholder={props.t('more_details')}
                  ></textarea>
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor="unit_value">{props.t('unit_value')}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="unit_value"
                    id="unit_value"
                    aria-invalid={errors.unit_value ? 'true' : 'false'}
                    placeholder={props.t('enter_unit_value')}
                    {...register('unit_value', { required: true })}
                  />
                  <span>{errors.unit_value && <p>{props.t('errors_champ')}</p>}</span>
                </FormGroup>

                <Button outline color="success" className="float-right" type="submit">
                  {props.t('save')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={handleCancel}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(CreateUnit);
